import { Link } from 'react-router-dom';

export default function LoginPortalButton() {
  return (
    <Link
      to="/login"
      className="fixed bottom-6 left-6 z-50 group"
      title="Employee Portal"
    >
      <div className="relative w-14 h-14 rounded-xl bg-gradient-to-br from-[var(--navy-mid)] to-[var(--navy-deep)] border border-white/10 backdrop-blur-sm shadow-lg hover:border-[var(--cyan-electric)]/50 transition-all duration-300 flex items-center justify-center group-hover:scale-110">
        {/* Icon */}
        <svg
          className="w-6 h-6 text-gray-400 group-hover:text-[var(--cyan-electric)] transition-colors"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
          />
        </svg>

        {/* Glow effect on hover */}
        <div className="absolute inset-0 rounded-xl bg-[var(--cyan-electric)]/20 opacity-0 group-hover:opacity-100 transition-opacity blur-sm" />

        {/* Tooltip */}
        <div className="absolute left-full ml-3 px-3 py-1.5 rounded-lg bg-[var(--navy-mid)] border border-white/10 text-sm text-white whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Employee Login
          <div className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-[var(--navy-mid)]" />
        </div>
      </div>
    </Link>
  );
}
